import React, { Component } from 'react'

import './TeamList.css'

/**
 * Modules
 */
import { Modal, List, Input, Button, message, Spin } from 'antd'
import { addATeam, deleteATeam, getTeams, updateATeam } from '../../../utils/competitorsFunctions'

class TeamList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            arrayOfTeams: [],
            filteredArrayOfTeams: [],
            teamInfoDialog: false,
            teamInfoObject: '',
            loading: false,

            teamAddDialog: false,
            teamAddObjectNome: '',
            loadingAdd: false,

            teamDeleteDialog: false,
            teamDeleteObject: '',

            teamEditDialog: false,
            teamEditObjectNome: '',
            teamEditObjectKey: '',
            loadingEdit: false,

            dataEditIsChanged: false,
        }
    }

    componentDidMount = async () => {
        this.setState({ loading: true })

        // Get all teams
        const teams = await getTeams();

        this.setState({
            arrayOfTeams: teams,
            filteredArrayOfTeams: teams,
            loading: false,
        });
    }

    /**
     * Methods to read team
     */
    searchTeam = (value) => {
        let localFilteredArray = []
        for (let key in this.state.arrayOfTeams) {
            if (this.state.arrayOfTeams[key]['nome'].toLowerCase().includes(value.toLowerCase())) {
                localFilteredArray.push(this.state.arrayOfTeams[key])
            }
        }
        this.setState({
            filteredArrayOfTeams: localFilteredArray
        })
    }

    openTeamInfoDialog = (teamObject) => {
        this.setState({
            teamInfoDialog: true,
            teamInfoObject: teamObject
        })
    }

    closeTeamInfoDialog = () => {
        this.setState({
            teamInfoDialog: false,
            teamInfoObject: ''
        })
    }

    /**
     * Methods to create team
     */
    openTeamAddDialog = () => {
        this.setState({
            teamAddDialog: true
        })
    }

    closeTeamAddDialog = () => {
        this.setState({
            teamAddDialog: false,
            teamAddObjectNome: ''
        })
    }

    addFieldValue = (field, value) => {
        this.setState({
            teamAddObjectNome: value
        })
    }

    createTeam = async () => {
        this.setState({ loadingAdd: true });

        const callbackAddTeam = await addATeam(
            {
                nome: this.state.teamAddObjectNome,
                wasDeleted: false
            },
        );

        if (!callbackAddTeam.error) {
            message.success('Equipe adicionada com sucesso.')
            this.setState({ loadingAdd: false })
            this.closeTeamAddDialog()
            this.componentDidMount()
        } else message.error(callbackAddTeam.message);
    }

    /**
     * Methods to delete team
     */
    openTeamDeleteDialog = (key) => {
        let _this = this
        Modal.confirm({
            title: 'Tem certeza que deseja excluir essa equipe?',
            content: 'Essa operação não poderá ser desfeita',
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Não',
            onOk() {
                _this.deleteTeam(key)
            }
        })
    }

    deleteTeam = async (key) => {

        // Update/Delete team in firebase
        await deleteATeam(key);
        message.success('Equipe deletada com sucesso.');
        this.componentDidMount();
    }

    /**
     * Methods to edit team
     */
    openTeamEditDialog = () => {
        let team = this.state.teamInfoObject
        this.setState({
            teamEditObjectKey: this.state.teamInfoObject.__key
        })
        this.setState({
            teamEditDialog: true,
            teamEditObjectNome: team.nome
        })
    }

    closeTeamEditDialog = () => {
        this.setState({
            teamEditDialog: false,
            teamEditObjectNome: '',
            dataEditIsChanged: false
        })
        this.closeTeamInfoDialog()
    }

    addEditFieldValue = (field, value) => {
        this.setState({
            teamEditObjectNome: value
        })
    }

    editTeam = async () => {
        this.setState({ loadingEdit: true })

        // Update/Delete team in firebase
        const callbackUpdateTeam = await updateATeam(
            this.state.teamEditObjectKey,
            {
                nome: this.state.teamEditObjectNome,
                wasDeleted: false
            },
        );

        if (!callbackUpdateTeam.error) {
            message.success('Equipe editada com sucesso.')
            this.setState({ loadingEdit: false })
            this.closeTeamEditDialog()
            this.componentDidMount()
        } else message.error(callbackUpdateTeam.message);
    }

    /**
     * Method to sort an array of objects
     */
    sortArray = (variable) => {
        let localArrayToSort = this.state.filteredArrayOfTeams
        new Promise((resolve, reject) => {
            resolve(this.setState({ variableToSort: variable }))
        })
            .then(() => {
                localArrayToSort.sort(this.sortStepByStep)
                this.setState({
                    filteredArrayOfTeams: localArrayToSort
                })
            })
    }

    sortStepByStep = (a, b) => {
        if (a[this.state.variableToSort] < b[this.state.variableToSort])
            return -1;
        if (a[this.state.variableToSort] > b[this.state.variableToSort])
            return 1;
        return 0;
    }

    render() {

        return (
            <div>
                <div className="teamListBlock" style={{ marginTop: 0, width: '100%' }}>
                    <div className="sharedSearchteamListBlock">
                        <Input
                            placeholder="Buscar equipe"
                            onKeyUp={input => this.searchTeam(input.target.value)}
                            id="searchInput"
                            className='sharedInput browser-default'
                            style={{ width: '49%', marginRight: '2%' }}
                        />

                        <Button
                            onClick={() => this.openTeamAddDialog()}
                            style={{ width: '49%' }}
                        >
                            Nova equipe
                        </Button>
                    </div>

                    {this.state.loading ? <Spin style={{ width: '100%', marginTop: '20px', marginBottom: '20px' }} /> :
                        <List
                            itemLayout="horizontal"
                            dataSource={this.state.filteredArrayOfTeams}
                            renderItem={item => (
                                <List.Item actions={[<a style={{ color: 'red' }} onClick={() => this.openTeamDeleteDialog(item.__key)}><i className="fas fa-trash"></i></a>]}>
                                    <List.Item.Meta
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.openTeamInfoDialog(item)}
                                        title={item.nome}
                                    />
                                </List.Item>
                            )}
                        />
                    }
                </div>

                <Modal
                    title="Informação da equipe"
                    visible={this.state.teamInfoDialog}
                    onCancel={this.closeTeamInfoDialog}
                    footer={[
                        <Button key='edit' onClick={this.openTeamEditDialog}>Editar</Button>,
                        <Button key='cancel' onClick={this.closeTeamInfoDialog}>Cancelar</Button>,
                    ]}
                >
                    <div style={{ float: 'left', width: '80%' }}>
                        Nome: {this.state.teamInfoObject.nome}
                    </div>
                    <div style={{ float: 'left', width: '20%', textAlign: 'center' }}>
                        {this.state.teamInfoFile !== undefined ?
                            <img id="profilePhoto" alt="profilePhoto" width="100%" /> : null
                        }
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </Modal>

                <Modal
                    title="Cadastro de equipe"
                    visible={this.state.teamAddDialog}
                    onCancel={this.closeTeamAddDialog}
                    footer={[
                        <Button key='register' loading={this.state.loadingAdd} onClick={this.createTeam}>Cadastrar</Button>,
                        <Button key='cancel' onClick={this.closeTeamAddDialog}>Cancelar</Button>,
                    ]}
                >
                    <Input
                        placeholder="Nome da equipe"
                        className='sharedInput browser-default'
                        style={{ width: '100%' }}
                        onKeyUp={input => this.addFieldValue('nome', input.target.value)}
                    />

                </Modal>

                <Modal
                    title="Atualização de equipe"
                    visible={this.state.teamEditDialog}
                    onCancel={this.closeTeamEditDialog}
                    footer={[
                        <Button key='update' loading={this.state.loadingEdit} onClick={this.editTeam}>Atualizar</Button>,
                        <Button key='cancel' onClick={this.closeTeamEditDialog}>Cancelar</Button>,
                    ]}
                >
                    <Input
                        placeholder="Nome da equipe"
                        className='sharedInput'
                        style={{ width: '100%' }}
                        onKeyUp={input => this.addEditFieldValue('nome', input.target.value)}
                        defaultValue={this.state.teamEditObjectNome}
                    />
                </Modal>
            </div>
        )
    }
}

export default TeamList